import Phaser from 'phaser';

import { BootScene } from '@/features/laneChooser/game/scenes/BootScene';
import { LaneChooserThemeScene } from '@/features/laneChooser/game/scenes/LaneChooserThemeScene';
import { shouldUseCanvasRenderer } from '@/shared/utils/browser';
import { getDevicePixelRatio } from '@/shared/utils/phaserCanvasSize';

import type { LaneChooserEventBus } from '@/features/laneChooser/game/EventBus';
import type { LaneChooserGameTheme } from '@/features/laneChooser/game/types';

export function createGameConfig(
	parent: HTMLElement,
	eventBus: LaneChooserEventBus,
	themeConfig: LaneChooserGameTheme,
): Phaser.Types.Core.GameConfig {
	const devicePixelRatio = getDevicePixelRatio();

	return {
		type: shouldUseCanvasRenderer() ? Phaser.CANVAS : Phaser.AUTO,
		parent,
		width: Math.max(1, Math.round((parent.clientWidth || 800) * devicePixelRatio)),
		height: Math.max(1, Math.round((parent.clientHeight || 600) * devicePixelRatio)),
		backgroundColor: '#ddfcff',
		scene: [new BootScene(themeConfig), new LaneChooserThemeScene(eventBus, themeConfig)],
		dom: {
			createContainer: true,
		},
		scale: {
			mode: Phaser.Scale.NONE,
		},
		antialias: true,
		roundPixels: true,
	};
}
